<template>
  <v-container style="max-width: 1000px">
    <QuickNavigation :fileData="fileData" :routeHistory="$route" />
    <section v-if="response">
      <section v-if="response.status === 200">
        <v-card id="coc" class="pa-4">
          <section class="mx-auto" style="max-width: 760px">
            <v-simple-table
              v-if="cocRequestHistory && cocRequestHistory.length > 0"
              class="table--bordered table--striped"
              dense
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <td>No</td>
                    <td>Date</td>
                    <td>Download Link</td>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(h, index) in cocRequestHistory"
                    :key="`history_${index}`"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>
                      {{ h.requestDateTime | moment("MM/DD/YYYY hh:mm A") }}
                    </td>
                    <td>
                      <a
                        href="#"
                        class="text-decoration-none"
                        v-on:click.prevent="
                          downloadEmbeddedDoc(h.embeddedDocId)
                        "
                      >
                        Download Coc request form
                        <v-icon small> mdi-download </v-icon>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-form v-if="coc" ref="cocForm" @submit.prevent="validateCoc">
              <div ref="pdfContainer" class="pa-2">
                <p>
                  Please choose the following reason(s) that changed or was
                  found to be inaccurate after the Loan Estimate was disclosed:
                </p>
                <v-simple-table class="table--bordered">
                  <template v-slot:default>
                    <thead class="primary">
                      <tr>
                        <td class="white--text" width="30%">Reason</td>
                        <td class="white--text" width="20%">Category</td>
                        <td class="white--text" width="25%">Current Value</td>
                        <td class="white--text" width="25%">New Value</td>
                      </tr>
                    </thead>
                    <tbody
                      v-for="(cocModel, index) in coc.loanCocModel"
                      :key="`cocModel-${cocModel.displayName}-${index}`"
                    >
                      <tr :key="`cocModel-tr-${cocModel.displayName}-${index}`">
                        <td>
                          <v-select
                            v-if="
                              coc.loanCocModel[index].displayName ===
                              'Loan Program'
                            "
                            label="Reason"
                            v-model="coc.loanCocModel[index].changeReason"
                            :rules="[
                              !(
                                coc.loanCocModel[index].changeReason === null &&
                                isLoanProgramRequired
                              ) ||
                                `Program change required : Loan Amount is NOT eligible for this product.`,
                            ]"
                            :items="reasonList"
                            item-text="displayName"
                            item-value="key"
                            hide-details="auto"
                            dense
                            :error-messages="
                              coc.loanCocModel[index].changeReason === null &&
                              isLoanProgramRequired
                                ? `Program change required : Loan Amount is NOT eligible for this product.`
                                : null
                            "
                            @change="showReasonDetailModal('loan', index)"
                          ></v-select>
                          <v-select
                            v-else
                            label="Reason"
                            v-model="coc.loanCocModel[index].changeReason"
                            :items="reasonList"
                            item-text="displayName"
                            item-value="key"
                            hide-details="auto"
                            dense
                            @change="showReasonDetailModal('loan', index)"
                          ></v-select>
                        </td>
                        <td>
                          {{ coc.loanCocModel[index].displayName }}
                        </td>
                        <td>
                          {{ coc.loanCocModel[index].originalValue }}
                        </td>
                        <td>
                          <v-text-field
                            v-if="
                              coc.loanCocModel[index].changeReason &&
                              coc.loanCocModel[index].valueType === 'currency'
                            "
                            v-model="coc.loanCocModel[index].newValue"
                            v-mask="$store.state.mask.currency"
                            :rules="[required, currency]"
                            hide-details="auto"
                            prefix="$"
                            :background-color="
                              getPainting(
                                coc.loanCocModel[index].originalValue,
                                coc.loanCocModel[index].newValue
                              )
                            "
                            dense
                            @change="
                              loanModelChangeEvent(coc.loanCocModel[index])
                            "
                          ></v-text-field>
                          <v-text-field
                            v-else-if="
                              coc.loanCocModel[index].changeReason &&
                              coc.loanCocModel[index].valueType === 'point'
                            "
                            v-model="coc.loanCocModel[index].newValue"
                            v-mask="$store.state.mask.point"
                            :rules="[required, percent]"
                            hide-details="auto"
                            :background-color="
                              getPainting(
                                coc.loanCocModel[index].originalValue,
                                coc.loanCocModel[index].newValue
                              )
                            "
                            dense
                            @change="
                              loanModelChangeEvent(coc.loanCocModel[index])
                            "
                          ></v-text-field>
                          <v-select
                            v-else-if="
                              coc.loanCocModel[index].changeReason &&
                              coc.loanCocModel[index].valueType === 'list'
                            "
                            v-model="coc.loanCocModel[index].newValue"
                            :rules="[requiredNotAllowZero]"
                            hide-details="auto"
                            :background-color="
                              getPainting(
                                coc.loanCocModel[index].originalValue,
                                coc.loanCocModel[index].newValue
                              )
                            "
                            dense
                            :items="coc.loanCocModel[index].dropdownList"
                            item-text="displayName"
                            item-value="key"
                            :disabled="
                              coc.loanCocModel[index].dropdownList === null ||
                              coc.loanCocModel[index].dropdownList.length === 0
                            "
                            :error-messages="
                              coc.loanCocModel[index].dropdownList === null ||
                              coc.loanCocModel[index].dropdownList.length === 0
                                ? 'No value found'
                                : null
                            "
                            @change="
                              loanModelChangeEvent(coc.loanCocModel[index])
                            "
                          ></v-select>
                          <v-text-field
                            v-else-if="coc.loanCocModel[index].changeReason"
                            v-model="coc.loanCocModel[index].newValue"
                            :rules="[required]"
                            hide-details="auto"
                            :background-color="
                              getPainting(
                                coc.loanCocModel[index].originalValue,
                                coc.loanCocModel[index].newValue
                              )
                            "
                            dense
                            @change="
                              loanModelChangeEvent(coc.loanCocModel[index])
                            "
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr
                        v-if="
                          coc.loanCocModel[index].changeReasonDetail.length > 0
                        "
                        :key="`field-detail-${coc.loanCocModel[index].displayName}-${index}-${coc.loanCocModel[index].changeReason}`"
                      >
                        <td colspan="4">
                          <ul>
                            <li
                              v-for="(detail, j) in coc.loanCocModel[index]
                                .changeReasonDetail"
                              :key="`loan-detail-${index}-${j}`"
                            >
                              {{ detail }}
                            </li>
                          </ul>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <v-checkbox
                  v-model="coc.hasUpdatedFees"
                  label="Update Fees"
                ></v-checkbox>
                <v-simple-table
                  v-if="coc.hasUpdatedFees"
                  class="table--bordered"
                >
                  <template v-slot:default>
                    <thead class="primary">
                      <tr>
                        <td class="white--text" width="30%">Reason</td>
                        <td class="white--text" width="20%">Category</td>
                        <td class="white--text" width="25%">Current Value</td>
                        <td class="white--text" width="25%">New Value</td>
                      </tr>
                    </thead>
                    <tbody
                      v-for="(feeModel, index) in coc.feeCocModel"
                      :key="`feeModel-${feeModel.displayName}-${index}`"
                    >
                      <tr
                        v-if="feeModel.displayName !== 'CDA Fee'"
                        :key="`feeModel-tr-${feeModel.displayName}-${index}`"
                      >
                        <td>
                          <v-select
                            label="Reason"
                            v-model="coc.feeCocModel[index].changeReason"
                            :items="reasonList"
                            item-text="displayName"
                            item-value="key"
                            hide-details="auto"
                            dense
                            @change="showReasonDetailModal('fee', index)"
                          ></v-select>
                        </td>
                        <td>
                          {{ coc.feeCocModel[index].displayName }}
                        </td>
                        <td>
                          {{
                            coc.feeCocModel[index].originalValue
                              | currency("$", 2, 1)
                          }}
                        </td>
                        <td>
                          <v-text-field
                            v-if="
                              coc.feeCocModel[index].changeReason &&
                              coc.feeCocModel[index].valueType === 'currency'
                            "
                            v-model="coc.feeCocModel[index].newValue"
                            v-mask="$store.state.mask.currency"
                            :rules="[required, currency]"
                            hide-details="auto"
                            prefix="$"
                            :background-color="
                              getPainting(
                                coc.feeCocModel[index].originalValue,
                                coc.feeCocModel[index].newValue
                              )
                            "
                            dense
                          ></v-text-field>
                          <v-text-field
                            v-else-if="
                              coc.feeCocModel[index].changeReason &&
                              coc.feeCocModel[index].valueType === 'point'
                            "
                            v-model="coc.feeCocModel[index].newValue"
                            v-mask="$store.state.mask.point"
                            :rules="[required, percent]"
                            hide-details="auto"
                            :background-color="
                              getPainting(
                                coc.feeCocModel[index].originalValue,
                                coc.feeCocModel[index].newValue
                              )
                            "
                            dense
                          ></v-text-field>
                          <v-text-field
                            v-else-if="coc.feeCocModel[index].changeReason"
                            v-model="coc.feeCocModel[index].newValue"
                            :rules="[required]"
                            hide-details="auto"
                            :background-color="
                              getPainting(
                                coc.feeCocModel[index].originalValue,
                                coc.feeCocModel[index].newValue
                              )
                            "
                            dense
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr v-else>
                        <td>
                          <v-select
                            label="Reason"
                            v-model="coc.feeCocModel[index].changeReason"
                            :items="cdaFeeReason"
                            item-text="displayName"
                            item-value="displayName"
                            hide-details="auto"
                            dense
                            @change="changeCdaFee(coc.feeCocModel[index])"
                          ></v-select>
                        </td>
                        <td>CDA Fee</td>
                        <td></td>
                        <td>
                          {{ coc.feeCocModel[index].newValue }}
                        </td>
                      </tr>
                      <tr
                        v-if="
                          coc.feeCocModel[index].changeReasonDetail.length > 0
                        "
                        :key="`field-detail-${coc.feeCocModel[index].displayName}-${index}-${coc.feeCocModel[index].changeReason}`"
                      >
                        <td colspan="4">
                          <ul>
                            <li
                              v-for="(detail, j) in coc.feeCocModel[index]
                                .changeReasonDetail"
                              :key="`loan-detail-${index}-${j}`"
                            >
                              {{ detail }}
                            </li>
                          </ul>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <v-checkbox
                  v-model="coc.hasAddedBorrowers"
                  label="Add New CoBorrower(s)"
                ></v-checkbox>
                <v-row v-if="coc.hasAddedBorrowers">
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="coc.coBorrowerEmail2"
                      label="1. Co-Borrower's Email"
                      :rules="[email]"
                      outlined
                      hide-details="auto"
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="coc.coBorrowerEmail3"
                      label="2. Co-Borrower's Email"
                      :rules="[email]"
                      hide-details="auto"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="coc.coBorrowerEmail4"
                      label="3. Co-Borrower's Email"
                      :rules="[email]"
                      hide-details="auto"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <div>
                      Upload 1003, Executed Borrower's Certification &
                      authorization and any other borrowers Docs below:
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <VueDropzone
                      ref="vDropzone"
                      id="vDropzone"
                      :options="dropzoneOption"
                      @vdropzone-error-multiple="vDropzoneErrorMultiple"
                      @vdropzone-success-multiple="vDropzoneSuccessMultiple"
                      @vdropzone-queue-complete="vDropzoneQueueCompleteMultiple"
                    ></VueDropzone>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-alert
                      v-if="
                        !(
                          coc.loanCocModel.some((x) => x.changeReason) ||
                          coc.feeCocModel.some((x) => x.changeReason)
                        )
                      "
                      dense
                      border="left"
                      type="warning"
                    >
                      You must select at least one reason above to activate this
                      section.
                    </v-alert>
                    <v-textarea
                      v-model="coc.additionalInformation"
                      label="Additional Information"
                      placeholder="COMMENTS COMES HERE"
                      hide-details="auto"
                      :disabled="
                        !(
                          coc.loanCocModel.some((x) => x.changeReason) ||
                          coc.feeCocModel.some((x) => x.changeReason)
                        )
                      "
                      :rules="
                        coc.loanCocModel.find(
                          (x) => x.displayName === 'Loan Program'
                        ).newValue === 'NotInList'
                          ? [
                              (v) =>
                                !!v ||
                                'What kind of Loan Program do you want to change to?',
                            ]
                          : []
                      "
                      outlined
                      dense
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" md="4">
                    <span class="text-h5 font-weight-bold">Requested By</span>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="coc.requestByName"
                      label="Name"
                      :rules="[required]"
                      hide-details="auto"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="coc.requestByTitle"
                      label="Title"
                      :rules="[required]"
                      hide-details="auto"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
              </div>
              <v-row>
                <v-col v-if="errorMessage" cols="12">
                  <span class="text-h6 error--text">{{ errorMessage }}</span>
                </v-col>
                <v-col cols="12" md="6">
                  <v-btn
                    type="submit"
                    color="primary"
                    elevation="0"
                    :loading="submitting"
                    block
                  >
                    Submit
                  </v-btn>
                </v-col>
                <v-col cols="12" md="6">
                  <v-btn
                    type="button"
                    color="default"
                    @click="initCocForm"
                    outlined
                    block
                  >
                    Clear
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </section>
        </v-card>
        <v-dialog v-model="reasonDetailModal.show" persistent max-width="500">
          <v-card>
            <v-card-title class="text-title-1">
              Please select the reason for the change.
            </v-card-title>
            <v-card-text>
              <template v-if="reasonDetailModal.type === 'loan'">
                <v-checkbox
                  v-for="d in reasonDescriptionList.filter((x) =>
                    x.key.includes(
                      coc.loanCocModel[reasonDetailModal.index].changeReason
                    )
                  )"
                  :key="d.key"
                  v-model="
                    coc.loanCocModel[reasonDetailModal.index].changeReasonDetail
                  "
                  :label="d.displayName"
                  :value="d.displayName"
                  hide-details="auto"
                  dense
                >
                </v-checkbox>
              </template>
              <template v-else-if="reasonDetailModal.type === 'fee'">
                <v-checkbox
                  v-for="d in reasonDescriptionList.filter((x) =>
                    x.key.includes(
                      coc.feeCocModel[reasonDetailModal.index].changeReason
                    )
                  )"
                  :key="d.key"
                  v-model="
                    coc.feeCocModel[reasonDetailModal.index].changeReasonDetail
                  "
                  :label="d.displayName"
                  :value="d.displayName"
                  hide-details="auto"
                  dense
                >
                </v-checkbox>
              </template>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="secondary"
                outlined
                @click="reasonDetailModal.show = false"
              >
                Confirm
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </section>
      <section v-else>
        <div class="error--text">{{ response.data }}</div>
      </section>
    </section>
    <section v-else>Loading...</section>
  </v-container>
</template>

<style>
#coc .v-input {
  font-size: 12px;
}
</style>

<script>
import { rules, convert } from "@/mixins";
import axios from "axios";
import QuickNavigation from "@/components/QuickNavigation";
import VueDropzone from "vue2-dropzone";
import PriceService from "@/services/nwapp/price.service";

export default {
  name: "ChangeOfCircumstances",
  components: {
    QuickNavigation,
    VueDropzone,
  },
  async created() {
    this.response = await this.$store
      .dispatch("fileDataApi/getFileDataDetail", {
        loanNumber: this.$route.query.loanNumber,
      })
      .catch((err) => err);

    if (this.response.status > 300) {
      this.$store.commit("statusDialog/showErrorDialog", this.response.data);
      this.$router.go(-1);
    }

    this.fileData = this.response.data;
    await this.initCocForm();
  },
  data() {
    return {
      response: null,
      fileData: null,
      coc: null,
      reasonDetailModal: {
        type: null,
        index: null,
        show: false,
      },
      cocRequestHistory: null,
      submitting: false,
      errorMessage: null,
      isLoanProgramRequired: false,
      cdaFeeReason: [
        { key: null, displayName: "" },
        { key: "$165.00", displayName: "Regular order ($165)" },
        { key: "$205.00", displayName: "Rush order ($205)" },
      ],
      reasonList: [
        { key: null, displayName: " " },
        { key: "settlement", displayName: "Settlement" },
        { key: "eligibility", displayName: "Eligibility" },
        { key: "consumer", displayName: "Consumer Request" },
        {
          key: "compensation_type_change",
          displayName: "Compensation Type Change",
        },
        { key: "rate_lock", displayName: "Rate Lock" },
        { key: "expiration_of_loan_estimate", displayName: "Expiration of LE" },
        { key: "new_con", displayName: "New Construction" },
        { key: "no_reason", displayName: "No reason needed" },
        { key: "other", displayName: "Not a Valid COC" },
      ],
      reasonDescriptionList: [
        {
          key: "rate_lock",
          displayName:
            "Loan locked with consumer after initial GFE is provided (consumer lock date)",
        },
        { key: "rate_lock", displayName: "Lock period expires (Extension)" },
        {
          key: "eligibility",
          displayName:
            "Credit quality change due to new information received (FICO, DTI, income change, etc.)",
        },
        {
          key: "rate_lock,expiration_of_loan_estimate",
          displayName: "Lock period expires (re-lock)",
        },
        {
          key: "eligibility",
          displayName:
            "Property type change (single family to multifamily, single family to PUD, condo to PUD, etc.)",
        },
        { key: "eligibility,consumer", displayName: "Loan amount changes" },
        { key: "consumer", displayName: "Borrower request to change a lock" },
        { key: "eligibility,new_con", displayName: "Property value changes" },
        {
          key: "consumer,eligibility",
          displayName: "Parties are added or removed from title",
        },
        {
          key: "eligibility,consumer,new_con",
          displayName: "Occupancy type changes",
        },
        {
          key: "consumer",
          displayName:
            "Borrower requests an escrow waiver or decides to no longer waive escrows",
        },
        {
          key: "eligibility,settlement",
          displayName:
            "Discovery of undisclosed unreleased liens affecting settlement costs",
        },
        {
          key: "eligibility",
          displayName:
            "Unique property not known or not disclosed at time of application which affects cost of appraisal",
        },
        {
          key: "consumer,settlement",
          displayName:
            "Lender quotes basic owner’s title insurance policy charge. however, borrower chooses an enhanced owner’s title policy",
        },
        {
          key: "other",
          displayName:
            "Acts of God, war, disaster, or other emergency (i.e. any federal disaster declared by President ? fires, flooding, earthquake, hurricane, tornado, etc.)",
        },
        {
          key: "eligibility",
          displayName:
            "Underwriting requirements for additional services (pest, structural inspection, upgraded appraisal, survey, flood insurance, etc.)",
        },
        {
          key: "consumer",
          displayName:
            "Borrower Requested Change (requires LOE from Borrower to be submitted with this form)",
        },
        {
          key: "compensation_type_change",
          displayName: "Must be benefit to Borrower. (APR must be lowered)",
        },
      ],
      dropzoneOption: {
        url: `${process.env.VUE_APP_API_BASE_URL}/api/BytePro/EmbeddedDoc/Dropzone`,
        headers: { Authorization: "Bearer " + this.$store.state.token },
        acceptedFiles: "image/*,application/pdf,.html,.doc,.docx,.txt",
        thumbnailWidth: 200,
        addRemoveLinks: true,
        maxFiles: 10,
        maxFilesize: 100, // 100 MB
        autoProcessQueue: false,
        uploadMultiple: true,
        paramName: () => "files",
        dictDefaultMessage:
          "<p class='text-h6'>Upload your 1003 or Executed Borrower's Certification & authorization</p><p class='text-hsubtitle-1'>(You may upload up to 10 files)</p>",
      },
    };
  },
  methods: {
    downloadEmbeddedDoc(embeddedDocId) {
      this.$store.commit("setGlobalLoading", true);
      this.$store
        .dispatch("embeddeddoc/getOne", {
          fileDataId: this.fileData.fileDataId,
          embeddedDocId: embeddedDocId,
        })
        .then((resp) => {
          this.downloadFile(
            resp.data.description + "_" + resp.data.guid,
            resp.data.fileExtension,
            resp.data.documentData
          );
        })
        .catch((err) => {
          this.$store.commit("statusDialog/showErrorDialog", err.response.data);
        })
        .finally(() => {
          this.$store.commit("setGlobalLoading", false);
        });
    },
    downloadFile(sourceName, sourceExtension, base64) {
      const element = document.createElement("a");
      const fileName = `${sourceName}.${sourceExtension}`;

      element.setAttribute(
        "href",
        `data:application/octet-stream;base64,${encodeURIComponent(base64)}`
      );
      element.setAttribute("download", fileName);
      element.click();
    },
    getPainting(originValue, newValue) {
      return newValue && originValue !== newValue ? "warning" : "default";
    },
    showReasonDetailModal(type, index) {
      if (type === "loan") {
        this.coc.loanCocModel[index].changeReasonDetail = [];
      } else if (type === "fee") {
        this.coc.feeCocModel[index].changeReasonDetail = [];
      }

      if (type === "loan" && this.coc.loanCocModel[index].changeReason) {
        this.reasonDetailModal.type = type;
        this.reasonDetailModal.index = index;
        this.reasonDetailModal.show = true;
      } else if (type === "fee" && this.coc.feeCocModel[index].changeReason) {
        this.reasonDetailModal.type = type;
        this.reasonDetailModal.index = index;
        this.reasonDetailModal.show = true;
      }
    },
    async initCocForm() {
      // this.response = null;
      const historyRet = await this.getCocRequestHistory(
        this.$route.query.loanNumber
      ).catch((err) => err.response);
      if (historyRet.status === 200) {
        this.cocRequestHistory = historyRet.data;
      }

      this.response = await this.getCocVM(this.$route.query.loanNumber).catch(
        (err) => err.response
      );

      if (this.response.status === 200) {
        this.coc = this.response.data;

        let loanProgram = this.coc.loanCocModel.find(
          (x) => x.displayName === "Loan Program"
        );
        loanProgram.newValue = null;
        loanProgram.dropdownList = [];

        const eligibleLoanList = await PriceService.getEligibleProgramList(
          this.fileData
        )
          .then((resp) => resp.data)
          .catch(() => null);

        loanProgram.dropdownList.push({
          key: `NotInList`,
          displayName: `Not In List`,
        });

        eligibleLoanList.forEach((item) => {
          if (item.eligibility) {
            loanProgram.dropdownList.push({
              key: item.loanProgramCode,
              displayName: `${item.loanProgramCode} [${item.loanProgramName}]`,
            });
          }
        });
      }
    },
    async loanModelChangeEvent(loanModel) {
      if (loanModel.displayName === "Loan Amount") {
        let loanProgram = this.coc.loanCocModel.find(
          (x) => x.displayName === "Loan Program"
        );
        loanProgram.newValue = null;
        loanProgram.dropdownList = [];
        this.fileData.loan.baseLoan = loanModel.newValue;
        this.fileData.loan.dti = null;
        let cloneFileData = this.toOriginTypeFileData(this.fileData);
        cloneFileData.loan.ltv =
          (cloneFileData.loan.baseLoan / cloneFileData.loan.purPrice) * 100;
        cloneFileData.loan.cltv =
          (cloneFileData.loan.baseLoan / cloneFileData.loan.purPrice) * 100;

        const eligibleLoanList = await PriceService.getEligibleProgramList(
          cloneFileData
        )
          .then((resp) => resp.data)
          .catch(() => null);

        loanProgram.dropdownList.push({
          key: `NotInList`,
          displayName: `Not In List`,
        });

        eligibleLoanList.forEach((item) => {
          if (item.eligibility) {
            loanProgram.dropdownList.push({
              key: item.loanProgramCode,
              displayName: `${item.loanProgramCode} [${item.loanProgramName}]`,
            });
          }
        });

        this.isLoanProgramRequired = !loanProgram.dropdownList.some(
          (x) => x.key === loanProgram.originalValue
        ); // loanProgram.originalValue: original program
      }
    },
    async getCocVM(loanNumber) {
      const resp = await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/api/Feature/BrokerService/CocVM?loanNumber=${loanNumber}`,
        {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        }
      );

      return resp;
    },
    async getCocRequestHistory(loanNumber) {
      const resp = await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/api/Feature/BrokerService/CocRequestHistory?loanNumber=${loanNumber}`,
        {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        }
      );

      return resp;
    },
    async uploadDocs(formData) {
      const resp = await axios.post(
        `${process.env.VUE_APP_API_BASE_URL}/api/BytePro/EmbeddedDoc/Dropzone`,
        formData,
        {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        }
      );

      return resp;
    },
    async requestCoc(cocVM) {
      const resp = await axios.post(
        `${process.env.VUE_APP_API_BASE_URL}/api/Feature/BrokerService/CocRequest`,
        cocVM,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.token}`,
          },
        }
      );

      return resp;
    },
    async validateCoc() {
      if (this.$refs.cocForm.validate()) {
        this.errorMessage = null;
        this.submitting = true;

        if (
          this.$refs.vDropzone &&
          this.$refs.vDropzone.getQueuedFiles().length > 0
        ) {
          this.$refs.vDropzone.processQueue();
        } else {
          const ret = await this.requestCoc(this.coc).catch(
            (err) => err.response
          );

          if (ret.status === 200) {
            this.$store.commit(
              "statusDialog/showSuccessDialog",
              "Your coc request has been successfully processed."
            );
            this.$router.push({
              path: "/pipeline/loan-detail",
              query: { loanNumber: this.$route.query.loanNumber },
            });
          } else {
            this.$store.commit("statusDialog/showErrorDialog", ret.data);
          }
          this.submitting = false;
        }
      } else {
        this.errorMessage = "Please check the data that has not been entered.";
      }
    },
    async vDropzoneErrorMultiple(files, response) {
      this.$store.commit("statusDialog/showErrorDialog", response);
    },
    async vDropzoneSuccessMultiple(files, response) {
      for (var i = 0; i < response.length; i++) {
        this.coc.uploadFileNames.push(response[i]);
      }
    },

    async vDropzoneQueueCompleteMultiple() {
      const ret = await this.requestCoc(this.coc).catch((err) => err.response);

      if (ret.status === 200) {
        this.$store.commit(
          "statusDialog/showSuccessDialog",
          "Your coc request has been successfully processed."
        );
        this.$router.push({
          path: "/pipeline/loan-detail",
          query: { loanNumber: this.$route.query.loanNumber },
        });
        this.submitting = false;
      } else {
        this.$store.commit("statusDialog/showErrorDialog", ret.data);
      }
    },
    changeCdaFee(item) {
      item.newValue =
        this.cdaFeeReason?.find((x) => x.displayName === item.changeReason)
          ?.key ?? "";
    },
  },
  mixins: [rules, convert],
};
</script>
